// ** Third Party Components
// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.div`
	display: flex;
	align-items: center;
	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`}

	svg {
		display: inline-block;
		vertical-align: sub;
		height: 30px;
		fill: ${({ theme: { colors, isDarkMode }, $alwaysLigth }) =>
			$alwaysLigth
				? colors.whiteAlways
				: isDarkMode
				? colors.whiteAlways
				: colors.blackAlways};
	}
`;
const TwitterLogoIcon = ({ customMargin, alwaysLigth }) => {
	return (
		<StyledSvgIconContainer
			$customMargin={customMargin}
			$alwaysLigth={alwaysLigth}
		>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
				<path d="M13.346 10.932 18.88 4.5h-1.311l-4.805 5.585L8.926 4.5H4.5l5.803 8.446L4.5 19.69h1.311l5.074-5.898 4.053 5.898h4.426zM11.55 13.02l-.588-.84-4.678-6.693h2.014l3.776 5.4.588.842 4.907 7.02h-2.014z"></path>
			</svg>
		</StyledSvgIconContainer>
	);
};

export default TwitterLogoIcon;
